import styled, { css } from 'styled-components';
import { Paper, ToggleGroup as SharedToggleGroup, minBp, theme } from '@triumph/shared';
import _ChevronDown from 'src/assets/icons/chevron-down.svg';

export const Wrap = styled(Paper)`
  padding: 30px 20px;
  margin-bottom: 24px;
  position: relative;

  @media ${minBp('desktop')} {
    padding: 43px 62px;
  }
`;

export const Title = styled.h3`
  margin: 0 0 11px;
  font-size: 20px;
  line-height: 24px;
  font-family: ${theme.fonts.dinDemi};
  text-transform: uppercase;

  @media ${minBp('desktop')} {
    font-size: 22px;
    line-height: 30px;
    margin: 0 0 8px;
  }
`;

export const SharedTextStyles = css`
  color: #000;
  font-size: 16px;
`;

export const Text = styled.p`
  ${SharedTextStyles}
  margin-bottom: 8px;
`;

export const ContentToggle = styled.span`
  ${SharedTextStyles}
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 8px;

  ${({ isActive }) => `
    ${ChevronDown} {
      transform: ${isActive ? 'rotate(180deg)' : 'rotate(0)'};
    }
  `}
`;

export const ChevronDown = styled(_ChevronDown)`
  margin: 4px;
  width: 12px;
  height: 12px;

  path {
    ${({ theme }) => `
      fill: ${theme.colors.primary};
    `}
  }
`;

export const AdditionalContent = styled.p`
  ${SharedTextStyles}

  ${({ isActive }) => `
    display: ${isActive ? 'block' : 'none'};
    margin-bottom: 10px;
  `}
`;

export const Description = styled.div`
  font-size: 14px;
  padding-bottom: 18px;
  border-bottom: 1px solid ${theme.colors.hairline};
  margin-bottom: 27px;

  @media ${minBp('desktop')} {
    font-size: 16px;
    padding-bottom: 30px;
    margin-bottom: 40px;
  }
`;

export const Summary = styled.div`
  font-size: 13px;
  line-height: 22px;

  @media ${minBp('desktop')} {
    font-size: 14px;
  }
`;

export const EditButton = styled.button`
  appearance: none;
  background: transparent;
  padding: 0;
  margin: 0;
  border: 0;
  color: ${theme.colors.primary};
  font-size: 16px;
  font-family: inherit;
  text-transform: uppercase;
  position: absolute;
  top: 30px;
  right: 20px;

  @media ${minBp('desktop')} {
    top: 43px;
    right: 62px;
  }
`;

export const Rule = styled.hr`
  border: 0;
  border-top: 1px solid ${theme.colors.hairline};
  margin: 0 0 24px;

  @media ${minBp('desktop')} {
    display: none;
  }
`;

export const WhatNext = styled.div`
  margin-top: 24px;

  @media ${minBp('desktop')} {
    margin-top: 40px;
  }
`;

export const WhatNextTitle = styled.div`
  font-size: 14px;
  font-family: ${theme.fonts.dinDemi};
  text-transform: uppercase;
  padding-bottom: 12px;
  border-bottom: 1px solid ${theme.colors.hairline};
  margin-bottom: 18px;
  color: black;
`;

export const WhatNextContent = styled.div`
  font-size: 14px;
  line-height: 20px;

  @media ${minBp('desktop')} {
    font-size: 16px;
    line-height: 24px;
  }

  p:last-child {
    margin: 0;
  }
`;

export const Error = styled.div`
  background: black;
  padding: 11px 12px 9px;
  color: white;
  margin-bottom: 14px;
  display: inline-flex;
  align-items: center;
  font-size: 14px;

  @media ${minBp('desktop')} {
    margin-bottom: 16px;
  }

  span {
    flex: 1;
    width: 100%;
  }

  svg {
    min-width: 18px;
    min-height: 18px;
    width: 18px;
    height: 18px;
    margin-right: 8px;
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }
`;
